import _extends from 'babel-runtime/helpers/extends';
import React from 'react';
import { mergePlayers } from './step-services';

/**
 * The idea of withPlayer is to provide a way to combine multiple players (in a React way). That means,
 * connecting multiple players, overriding upper player properties with those that are lower in the hierarchy,
 * and in the same time allow player to use `this` in the getters and methods.
 * Player has certain complexity, but the benefit is that developer can work with it without constraints.
 */
export var withPlayer = function withPlayer(createPlayer) {
  return function (WrappedComponent) {
    return function (props) {
      return React.createElement(WrappedComponent, _extends({}, props, { player: mergePlayers(props.player, createPlayer(props)) }));
    };
  };
};